function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("rect", {
  width: 23.799,
  height: 21.053,
  transform: "translate(0 0)",
  fill: "#0078d7"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M308.7,432.437h18.279a.7.7,0,0,0,.448-.162c.176-.147,4.18-3.592,4.425-11.029H312.218c-.243,6.751-3.931,9.924-3.97,9.955a.7.7,0,0,0,.449,1.236Zm0,0",
  transform: "translate(-308 -415.595)",
  fill: "#0078d7"
})));

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M395.166,332.641h-3.5v-.7a.7.7,0,1,0-1.4,0v.7h-3.544v-.7a.7.7,0,1,0-1.4,0v.7h-3.5v-.7a.7.7,0,0,0-1.4,0v.7h-3.5a.693.693,0,0,0-.7.7v2.1h19.631v-2.1a.693.693,0,0,0-.7-.7Zm0,0",
  transform: "translate(-371.992 -331.187)",
  fill: "#0078d7"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M392.315,536.645a2.1,2.1,0,0,1-1.346.489H376.234v2.1a.7.7,0,0,0,.7.7h18.232a.7.7,0,0,0,.7-.7v-7.841a13.859,13.859,0,0,1-3.55,5.254Zm0,0",
  transform: "translate(-371.992 -518.893)",
  fill: "#0078d7"
});

function SvgCalendarIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 23.873,
    height: 21.053,
    viewBox: "0 0 23.873 21.053",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar-icon.a121d490.svg";
export { ForwardRef as ReactComponent };